import React from 'react';
import { CustomizableItem } from '../../../../../components/CustomizeItems/CustomizeItems';
import { CustomizeItemsModal } from '../../../../../components/CustomizeItems';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { TimeSheetColumnSetting } from './types';

type Props = {
  visible: boolean;
  timeSheetColumnSettings: TimeSheetColumnSetting[];
  // Display titles for dynamic extra-field columns, keyed by column id.
  // Built-in columns fall back to their translated header.
  extraColumnTitles?: Record<string, string>;
  onSave: (value: TimeSheetColumnSetting[]) => void;
  onClose: () => void;
};

export const CustomizeTableColumnsModal: React.FC<
  React.PropsWithChildren<Props>
> = ({
  timeSheetColumnSettings,
  extraColumnTitles,
  onSave,
  visible,
  onClose,
}) => {
  const t = useNamespacedTranslation('timeSheetsControlling.table');

  const customizableItems = timeSheetColumnSettings.map((columnSetting) => ({
    id: columnSetting.id,
    checked: columnSetting.checked,
    name:
      extraColumnTitles?.[columnSetting.id] ?? t('header.' + columnSetting.id),
  }));

  const handleOnSave = (items: CustomizableItem[]) => {
    onSave(items.map((x) => ({ id: x.id, checked: x.checked })));
    onClose();
  };

  return (
    <CustomizeItemsModal
      items={customizableItems}
      header={t('customizeColumns')}
      onSave={handleOnSave}
      visible={visible}
      onClose={onClose}
      isProcessing={false}
    />
  );
};
